module.exports = __webpack_public_path__ + "img/问卷调查录入.b711c6a8.png";